module.exports = __webpack_public_path__ + "static/warlock_archfey_elf_female-f4e59d211c6b4b67843826338e13b0bf.jpg";